import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const ThemeCtx = createContext();
const LS_KEY = "fm_theme"; // "light" | "dark"

function getInitialTheme() {
  const saved = typeof window !== "undefined" ? localStorage.getItem(LS_KEY) : null;
  if (saved === "light" || saved === "dark") return saved;
  // default to system preference
  return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function ThemeProvider({ children, theme: controlledTheme }) {
  const [theme, setTheme] = useState(getInitialTheme);
  const resolvedTheme = controlledTheme === "dark" || controlledTheme === "light" ? controlledTheme : theme;

  // reflect to <html> as a class
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("theme-dark", "theme-light");
    root.classList.add(resolvedTheme === "dark" ? "theme-dark" : "theme-light");
    localStorage.setItem(LS_KEY, resolvedTheme);
  }, [resolvedTheme]);

  const value = useMemo(
    () => ({
      theme: resolvedTheme,
      setTheme,
      toggle: () => setTheme((t) => (t === "dark" ? "light" : "dark")),
    }),
    [resolvedTheme]
  );

  return <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>;
}

export function useTheme() {
  return useContext(ThemeCtx);
}
